import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';
import { ContentPromotionPostsRadioProps } from './types';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionPostsRadio' })
    .attrs<ContentPromotionPostsRadioProps>((props) => ({
        p: 2,
        borderRadius: 2,
        width: { xs: '100%', sm: 195 },
        height: '100%',
        background: props.checked
            ? 'var(--control-secondary-background)'
            : 'var(--background-primary)',
        border: props.checked ? '1px solid transparent' : '1px solid var(--placeholder)',
        direction: { xs: 'row', sm: 'column' },
    }))``;
